













































import useTemplates from "@/composables/v3/useTemplates";
import { useChannelsStore } from "@/store/useChannelsStore";
import { useTemplatesStore } from "@/store/useTemplatesStore";
import { RequestQueryBuilder } from "@rewiko/crud-request";
import { computed, defineComponent } from "@vue/composition-api";
import { BButton, BCardText, BListGroup, BListGroupItem, BOverlay } from "bootstrap-vue";

export default defineComponent({
    components: {
        BListGroup,
        BListGroupItem,
        BCardText,
        BOverlay,
        BButton,
    },
    emits: ["manage-template"],
    setup() {
        const { fetchVariablesFromContent, setTemplate, templateSearchString } = useTemplates();
        const channelsStore = useChannelsStore();
        const templatesStore = useTemplatesStore();
        templatesStore.fetchTemplates(
            RequestQueryBuilder.create({
                join: { field: "channels", select: ["id"] },
                fields: ["title", "content", "components", "mediaType", "assetId", "assetIsLocked"],
                filter: [
                    { field: "channels.id", operator: "$eq", value: channelsStore.activeChatChannel?.id },
                    {
                        field: "status",
                        operator: "$eq",
                        value: "approved",
                    },
                ],
            })
        );

        const textTemplates = computed(() => {
            return templatesStore.textTemplates.filter((template) =>
                //lodash.startsWith(template.title.toLowerCase(), templateSearchString.value.toLowerCase())
                template.title.toLowerCase().includes(templateSearchString.value.toLowerCase())
            );
        });

        return {
            textTemplates,
            templatesStore,
            setTemplate,
            fetchVariablesFromContent,
        };
    },
});
